export default {
  zh: {//China No.1
    userPlod:'用户名',
    passwordPlod:'密码',
    errorTexl:'',
    LoginIn:'',
  },
  en: {
    userPlod:'userName',
    passwordPlod:'password',
    errorTexl:'username or password error',
    LoginIn:'Login in',
  },
  ar: { // 阿拉伯
    userPlod:'اسم المستخدم',
    passwordPlod:'كلمة المرور',
    errorTexl:'خطا فى الاسم او الرقم السرى المستخدم',
    LoginIn:'الدخول في',
  },
  tr:{ //土耳其
    passwordPlod:'parola',
    userPlod:'kullanıcı adı',
    errorTexl:'Kullanıcı adı veya şifre hatası',
    LoginIn:'Giriş Yap',
  },
   pt: {
        "userPlod": "nomeDeUsuario",
        "passwordPlod": "senha",
        "errorTexl": "erro de nome de usuário ou senha",
        "LoginIn": "Entrar"
    },
    id: {
        "userPlod": "namaPengguna",
        "passwordPlod": "kataSandi",
        "errorTexl": "kesalahan nama pengguna atau kata sandi",
        "LoginIn": "Masuk"
    },
    uz: {
        "userPlod": "foydalanuvchiIsmi",
        "passwordPlod": "parol",
        "errorTexl": "foydalanuvchi nomi yoki parol xatosi",
        "LoginIn": "Kirish"
    },
    ru: {
        "userPlod": "имяПользователя",
        "passwordPlod": "пароль",
        "errorTexl": "ошибка имени пользователя или пароля",
        "LoginIn": "Войти"
    },
    fa: {
        "userPlod": "نامکاربری",
        "passwordPlod": "گذرواژه",
        "errorTexl": "خطا در نام کاربری یا گذرواژه",
        "LoginIn": "ورود"
    }
}


// WEBPACK FOOTER //
// src/pages/app/newpaypal/lang.js